import request from "axios";

/** 获取业务字典中的入口场景 */
export const getEntryScene = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "VOD_SCENE"
    }
  });
};
/** 获取推荐策略的列表 */
export const getRecommendStrategyList = () => {
  return request({
    url: "/lebo-vod/vod/tactics/list",
    method: "get",
    params: {
      status: 1,
    }
  });
}
/** 分页查询入口管理 */
export const getEntryManageList = (params) => {
  return request({
    url: "/lebo-vod/vod/scene/page",
    method: "get",
    params
  });
}
/** 新增入口管理的接口 */
export const addEntryItem = (data) => {
  return request({
    url: "/lebo-vod/vod/scene",
    method: 'post',
    data
  })
}
/** 修改入口管理的接口 */
export const updateEntryItem = (data) => {
  return request({
    url: "/lebo-vod/vod/scene",
    method: 'put',
    data
  })
}
/** 上线点播场景的接口 */
export const onlineEntryItem = (id) => {
  return request({
    url: `/lebo-vod/vod/scene/put-on/${id}`,
    method: 'put',
  })
}
/** 下线点播场景的接口 */
export const offlineEntryItem = (id) => {
  return request({
    url: `/lebo-vod/vod/scene/take-off/${id}`,
    method: 'put',
  })
}
/** 删除点播场景的接口 */
export const deleteEntryItem = (id) => {
  return request({
    url: `/lebo-vod/vod/scene/${id}`,
    method: 'delete',
  })
}
/** 获取点播场景操作日志的接口 */
export const getEntryItemLog = (params) => {
  return request({
    url: `/lebo-vod/vod/log/page`,
    method: 'get',
    params: {
      ...params,
      module: 4
    }
  })
}
/** 获取业务字典中的协议版本号 */
export const getProtocolVersion = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "VOD_PROTOCOL_VERSION"
    }
  });
};
